import React from 'react';
import { inject } from 'mobx-react';
import { Spring, animated } from 'react-spring';
import styled from 'styled-components';
import DeliveryProgressV2 from "js/components/core/DeliveryProgressV2";

const Progress = styled(DeliveryProgressV2)`
  display: row;
  justify-content: center;
  background: white;
  border-radius: 0.5rem;
  padding: 1rem 0;
`;

export default inject('page')(({ page }) => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {animation => (
      <animated.div style={animation}>
        <Progress shipment={page.shipment_tracking} />
      </animated.div>
    )}
  </Spring>
));


